<template>
  <div v-if="url">
    <a
      class="cell-link"
      :href="url">
      <slot />
    </a>
    <a
      class="inline"
      :href="url">
      <slot name="accessoryIcon" />
    </a>
  </div>
  <div v-else>
    <slot />
    <div
      v-if="showAccessory ?? hasUrl"
      class="inline"
      :class="{ 'invisible! hover:invisible!': hasUrl }">
      <slot name="accessoryIcon" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    url: String,
    hasUrl: Boolean,
    /** When true, accessory slot is rendered (e.g. url icon and/or exposure pencil). When false, slot is not rendered. */
    showAccessory: Boolean,
  },
};
</script>

<style scoped>
.cell-link {
  color: var(--v-text-base);
}
</style>
